import React from 'react';
import styled from 'styled-components';

import i18n from '@/settings/i18n';
import { organizationBillingContactStore } from '@/store/organization/billingContact';
import { Button, Modal } from 'semantic-ui-react';
import { Contact } from '@/types/contact';
import { BillingContactFormCreateContainer } from '@/components/pages/Subscription/Container/Form/Address/BillingContactFormCreateContainer';
import { BillingContactFormUpdateContainer } from '@/components/pages/Subscription/Container/Form/Address/BillingContactFormUpdateContainer';
import { useAppDispatch } from '@/store';

type Props = {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setFieldValue: {
    (
      field:
        | 'billingContactId'
        | 'contactId'
        | 'serviceIds'
        | 'adminIds'
        | 'users'
        | 'startsOn'
        | 'projectClassId',
      value: any,
      shouldValidate?: boolean | undefined,
    ): void;
    (field: string, value: any): void;
  };
  mode?: 'new' | 'edit';
  targetContact?: Contact;
};

export const ModalContents: React.FC<Props> = ({
  setIsOpen,
  setFieldValue,
  mode = 'new',
  targetContact,
}) => {
  const dispatch = useAppDispatch();
  return (
    <>
      <Modal.Header>
        <div>
          {i18n.t(
            `ui.subscription.contact.billingContactModal.${
              mode || 'new'
            }.title`,
          )}
        </div>
      </Modal.Header>
      <Modal.Content scrolling={true}>
        <WarningInputDisappear>
          {i18n.t(`ui.subscription.contact.contactModal.warningInputDisappear`)}
        </WarningInputDisappear>
        {mode === 'new' && (
          <BillingContactFormCreateContainer
            onComplete={() => {
              setIsOpen(false);
              dispatch(organizationBillingContactStore.asyncActions.fetchAll());
            }}
            setFieldValue={setFieldValue}
          />
        )}
        {mode === 'edit' && targetContact !== undefined && (
          <BillingContactFormUpdateContainer
            onComplete={() => {
              setIsOpen(false);
              dispatch(organizationBillingContactStore.asyncActions.fetchAll());
            }}
            setFieldValue={setFieldValue}
            contact={targetContact}
          />
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setIsOpen(false)}>
          {i18n.t(
            `ui.subscription.contact.contactModal.${mode || 'new'}.cancel`,
          )}
        </Button>
        <Button
          primary={true}
          onClick={() => {
            (
              document.getElementById(
                'address-form-submit-button',
              ) as HTMLButtonElement
            ).click();
          }}
        >
          {i18n.t(
            `ui.subscription.contact.contactModal.${mode || 'new'}.submit`,
          )}
        </Button>
      </Modal.Actions>
    </>
  );
};

const WarningInputDisappear = styled.div`
  font-size: 1em;
  font-weight: lighter;
  color: #ff0000;
  margin-bottom: 0.5em;
`;
